import { baseUrl } from "../../core/constant";
import { axiosInstance } from "../../core/useAxios";
import { getToken } from "../../utils/utils";

const MANAGEMENT_KEY = "voyage-labor-management-unlock";
export const getManagementUnlock = () => sessionStorage.getItem(MANAGEMENT_KEY) || "";
export const setManagementUnlock = (value: string) => value ? sessionStorage.setItem(MANAGEMENT_KEY, value) : sessionStorage.removeItem(MANAGEMENT_KEY);


export type LaborMethod = "GET" | "POST" | "PATCH";

export async function laborRequest<T>(
  method: LaborMethod,
  path: string,
  data?: any,
  params?: Record<string, any>
): Promise<T> {
  const token = getToken();
  const response = await axiosInstance({
    method,
    url: `${baseUrl}/api/labor/${path}`,
    data,
    params,
    headers: { ...(token ? { Authorization: `Token ${token}` } : {}), ...(path !== "management-unlock/" && getManagementUnlock() ? {"X-Labor-Management": getManagementUnlock()} : {}) },
  });
  return response.data as T;
}

export function laborApiError(error: any): string {
  const payload = error?.response?.data;
  if (typeof payload?.detail === "string") return payload.detail;
  if (typeof payload?.message === "string") return payload.message;
  if (payload && typeof payload === "object") {
    const messages = Object.entries(payload).flatMap(([field, value]) => {
      const items = Array.isArray(value) ? value : [value];
      return items.map(item => `${field}: ${String(item)}`);
    });
    if (messages.length) return messages.join(" ");
  }
  return error?.message || "The Labor request could not be completed.";
}
